import React, { Component } from 'react';

import feedSlide from 'assets/images/feed_slide.png';
import groupsSlide from 'assets/images/groups_slide.png';
import applicationsSlide from 'assets/images/applications_slide.png';
import mobileSlide from 'assets/images/mobile_slide.png';
import userManagementSlide from 'assets/images/user_management_slide.png';
import customisationSlide from 'assets/images/customisation_slide.png';

class CarouselView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.autoNextSlide = ::this.autoNextSlide;
    this.getSlides = ::this.getSlides;

    this.state = {
      activeSlideIndex: 0,
      slidesWidth: 0,
    };
    this.autoNextSlide();
  }

  componentDidMount() {
    this.calculateWidth();
    window.addEventListener('resize', ::this.calculateWidth, false);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    window.removeEventListener('resize', ::this.calculateWidth, false);
  }

  getSlides() {
    return [
      {
        name: () => this.props.translations['features.feed'],
        image: feedSlide,
        description: () => this.props.translations['features.feedDesc'],
      },
      {
        name: () => this.props.translations['features.groups'],
        image: groupsSlide,
        description: () => this.props.translations['features.groupsDesc'],
      },
      {
        name: () => this.props.translations['features.applications'],
        image: applicationsSlide,
        description: () => this.props.translations['features.applicationsDesc'],
      },
      {
        name: () => this.props.translations['features.customization'],
        image: customisationSlide,
        description: () => this.props.translations['features.customizationDesc'],
      },
      {
        name: () => this.props.translations['features.userManagement'],
        image: userManagementSlide,
        description: () => this.props.translations['features.userManagementDesc'],
      },
      {
        name: () => this.props.translations['features.mobile'],
        image: mobileSlide,
        description: () => this.props.translations['features.mobileDesc'],
      },
    ];
  }

  calculateWidth() {
    const slides = document.getElementById('slides');

    if (slides) {
      this.setState({
        slidesWidth: slides.getBoundingClientRect().x,
      });
    }
  }

  autoNextSlide() {
    this.timeout = setTimeout(() => {
      this.setState(
        prevState => ({
          activeSlideIndex:
            prevState.activeSlideIndex + 1 > this.getSlides().length - 1 ? 0 : prevState.activeSlideIndex + 1,
        }),
        () => {
          this.autoNextSlide();
        },
      );
    }, 5000);
  }

  render() {
    return (
      <div
        id="carousel"
        style={{
          width: '100vw',
          overflow: 'hidden',
        }}
      >
        <div className="container">
          <div className="squareboard-overview">
            <div className="selected-name u-text-dark-grey">{this.getSlides()[this.state.activeSlideIndex].name()}</div>
            <div className="selected-desc">{this.getSlides()[this.state.activeSlideIndex].description()}</div>
            <div className="squareboard-overview-nav">
              {this.getSlides().map((slide, index) => (
                <div
                  role="presentation"
                  className={`overview-nav-button${index === this.state.activeSlideIndex ? ' active' : ''}`}
                  onClick={() => {
                    clearTimeout(this.timeout);
                    this.setState({ activeSlideIndex: index }, () => {
                      this.autoNextSlide();
                    });
                  }}
                >
                  {slide.name()}
                </div>
              ))}
            </div>
          </div>
          <div
            className="squareboard-slides"
            id="slides"
            style={{
              width: `calc(100vw - ${this.state.slidesWidth}px)`,
            }}
          >
            <div className="squareboard-slide">
              <div className="slide-container">
                <img src={this.getSlides()[this.state.activeSlideIndex].image} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CarouselView;
